import Triggerable from "./Triggerable";
import Popover from "./Popover";

export default Triggerable(Popover);
